import { ResourceData } from '../types';
import { COLUMN_NAMES } from '../constants/columnNames';

export const downloadResourcesAsCSV = (filteredData: ResourceData[]): void => {
  if (!filteredData || filteredData.length === 0) return;

  const uniqueGovernanceTagNames = new Set<string>();
  filteredData.forEach((resource) => {
    resource.governanceTags?.forEach((tag) => {
      uniqueGovernanceTagNames.add(tag.name);
    });
  });

  const sortedGovernanceTagNames = Array.from(uniqueGovernanceTagNames).sort((a, b) => a.localeCompare(b));

  const governanceTagColumns = sortedGovernanceTagNames.map((_, index) => `virtualTag${index + 1}`);

  const csvColumns = [
    COLUMN_NAMES.RESOURCE_COST,
    COLUMN_NAMES.RESOURCE_NAME,
    COLUMN_NAMES.RESOURCE_ID,
    COLUMN_NAMES.SERVICE,
    COLUMN_NAMES.REGION,
    COLUMN_NAMES.LINKED_ACCOUNT,
    COLUMN_NAMES.TAGS,
    ...governanceTagColumns,
  ];

  const header = csvColumns.join(',') + '\n';

  const csvContent = filteredData
    .map((resource) => {
      const row = csvColumns.map((col) => {
        if (col === COLUMN_NAMES.TAGS) {
          return resource.tags
            ? `"${Object.entries(resource.tags)
                .map(([key, val]) => `${key}: ${val}`)
                .join('; ')
                .replace(/"/g, '""')}"`
            : '';
        }

        if (col.startsWith('virtualTag')) {
          const tagIndex = parseInt(col.replace('virtualTag', '')) - 1;
          const tagName = sortedGovernanceTagNames[tagIndex];
          const governanceTag = resource.governanceTags?.find((tag) => tag.name === tagName);
          return governanceTag ? `"${governanceTag.name}: ${String(governanceTag.value).replace(/"/g, '""')}"` : '';
        }

        const value = resource[col as keyof ResourceData];
        return value ? `"${String(value).replace(/"/g, '""')}"` : '';
      });

      return row.join(',');
    })
    .join('\n');

  const csv = header + csvContent;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `governance-tags-export-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
